export default __webpack_public_path__ + "static/media/3119.75deba67.jpg";